// extracted by mini-css-extract-plugin
export var box = "_81-1";
export var checkboxRow = "_81-8";
export var checked = "_81-2";
export var descriptionSpacer = "_81-a";
export var disabled = "_81-3";
export var icon = "_81-6";
export var input = "_81-0";
export var labelSpacer = "_81-9";
export var medium = "_81-5";
export var small = "_81-4";
export var text = "_81-7";